import React from "react";

import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IProps from "./props";

const DevForgotPassword = ({
  onSubmit,
  dataForm,
  errorMessage,
}: IProps): JSX.Element => (
  <S.Container>
    <S.Title>Esqueceu a senha?</S.Title>
    <S.SubTitle>
      Digite seu e-mail para que possamos te enviar um link para alterá-la
    </S.SubTitle>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      submitErrorMessage={errorMessage}
    />
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default DevForgotPassword;
